import { newRidgeState } from "react-ridge-state";

export interface CheckoutResponse {
	type: string;
	id: number;
	reason: string | null;
	recordType: string | null;
}

const checkoutResponseState = newRidgeState<CheckoutResponse | null>(null);
const isLoadingState = newRidgeState<boolean>(false);

export function useCheckoutResponse() {
	const [checkoutResponse, setCheckoutResponse] = checkoutResponseState.use();
	const [isLoading, setIsLoading] = isLoadingState.use();

	return {
		checkoutResponse,
		setCheckoutResponse,
		isLoading,
		setIsLoading,
	};
}
